export enum Constants {
  TOKEN_SET_NAME = 'TOKEN_SET_NAME',
  TOKEN_SET_IMAGE = 'TOKEN_SET_IMAGE',
  TOKEN_SET_DESCRIPTION = 'TOKEN_SET_DESCRIPTION',
  TOKEN_SET_DECIMALS = 'TOKEN_SET_DESCIMALS'
}